import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const query = graphql`
  {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`

const SEO = ({title, description}) => {
    const {site} = useStaticQuery(query)
    const metaDescription = description || site.siteMetadata.description
    console.log(site)
    return (
        <Helmet 
        title={`${title} | ${site.siteMetadata.title}`} 
        meta={[{name: `description`, content:description}]}
        htmlAttributes={{lang: "en"}}
        ></Helmet>
    )
}

export default SEO
